import { dateDiff, dateFormat } from '@mirai/locale';

import { getOccupationTotals } from '../components/helpers/getOccupationTotals';

const toIsoDate = (value) => (value ? dateFormat(value, { delimiter: '-', format: 'YYYY-MM-DD' }) : undefined);

const getSource = (urlParams = {}) => {
  const raw = (urlParams.utm_source || urlParams.source || urlParams.utm_medium)?.toLowerCase();
  const map = {
    google_ha: 'google_ha',
    googleha: 'google_ha',
    'google-hotel-ads': 'google_ha',
    hotelads: 'google_ha',
    tripadvisor: 'tripadvisor',
    trivago: 'trivago',
    skyscanner: 'skyscanner',
  };

  if (raw && map[raw]) return map[raw];
  if (urlParams.gclid || ['cpc', 'ppc', 'sem', 'paid'].includes(raw)) return 'ads';
  if (raw) return raw;

  return 'direct';
};

const getOccupationProps = ({ occupation = [], infantAge } = {}) => {
  if (!occupation?.length) return {};

  const { adults = 0, babies = 0, children = 0 } = getOccupationTotals({ infantAge, occupation });
  const roomCount = occupation.length;
  const totalPax = adults + babies + children;

  return { is_multiroom: roomCount > 1, room_count: roomCount, total_pax: totalPax, adults, children, babies };
};

const getSearchProps = ({ store = {}, dataSource = {} } = {}) => {
  const { finder = {}, currency, language, locale, urlParams = {} } = store;
  const { calendar = [], occupation = [], promocode } = finder;
  const [checkin, checkout] = calendar;

  const props = {
    source: getSource(urlParams),
    language,
    locale,
    currency,
    promo_code: !!promocode,
    utm_source: urlParams.utm_source?.toLowerCase(),
    checkin: toIsoDate(checkin),
    checkout: toIsoDate(checkout),
    lead_time_days: dateDiff(checkin, checkout).days,
    ...getOccupationProps({ occupation, infantAge: dataSource.infantAge }),
  };

  return Object.fromEntries(Object.entries(props).filter(([, value]) => value !== undefined && value !== ''));
};

export { getSearchProps };
